<template>
<div class="chapter">
<div class="inner_page">
<p class="SP"> </p>
<p class="Dedication-ded">Eine Geschichte für W.R.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?6152394b